var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLitecoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#345D9D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.197 24.6017C19.9055 24.6717 23.5462 24.7397 27.2548 24.8778C27.1189 25.428 26.981 25.9082 26.9131 26.3904C26.7053 27.0786 26.4995 27.6988 26.3636 28.3871C26.2937 28.7312 26.1558 28.7992 25.8141 28.7992H8.0924C8.71183 26.3904 9.32926 24.1215 9.9467 21.7126C8.98558 22.0568 8.16034 22.4009 7.19922 22.813C7.47497 21.7826 7.74871 20.8883 8.0924 19.924C8.0924 19.7879 8.29821 19.7179 8.43608 19.7179C9.05551 19.4438 9.74088 19.2357 10.3583 18.9597C10.5641 18.8935 10.7719 18.6875 10.7719 18.4794L13.6533 7.74943C13.7232 7.33726 13.8591 7.19922 14.3407 7.19922H20.5909C19.8356 10.0183 19.1482 12.8413 18.3929 15.7984C19.4919 15.3182 20.523 14.9041 21.6899 14.4919C21.552 15.0421 21.3462 15.5223 21.2783 16.0045C21.1404 17.1068 20.523 17.7251 19.424 18.0012C18.9444 18.1373 18.4609 18.3433 17.9813 18.5514C17.811 18.6533 17.6695 18.795 17.5697 18.9635C17.0881 20.8202 16.6066 22.6089 16.195 24.4656V24.6036L16.197 24.6017Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitecoin);
export default __webpack_public_path__ + "static/media/litecoin.cbb3b5eba6445e331301f98b633cffd4.svg";
export { ForwardRef as ReactComponent };